module.exports = __webpack_public_path__ + "img/sport_tabletennis.dc85a6e3.png";